// ผู้ให้บริการที่ AskPay รองรับ (ค่าที่ส่งให้ API ตรงกับที่แสดงบนหน้าจอ)
const ASKPAY_PROVIDER_CODES = ['apexpay', '424Pay']

// รูปแบบการแสดงข้อมูลการฝากเงินให้ลูกค้า
export const DEPOSIT_DISPLAY_TYPE_OPTIONS = [
    { value: 'qr_code', text: 'QR Code เท่านั้น' },
    { value: 'qr_code_and_account', text: 'QR Code และเลขบัญชี' },
    { value: 'account', text: 'เลขบัญชีเท่านั้น' },
]

const DEPOSIT_DISPLAY_TYPE_CONFIG = {
    key: 'depositDisplayType',
    label: 'การแสดงข้อมูลการฝากเงิน',
    options: DEPOSIT_DISPLAY_TYPE_OPTIONS,
}

export const PAYMENT_GATEWAY = {
    'cut-payz': {
        name: 'CutPayz',
        isAllowedDeposit: true,
        isAllowedWithdraw: true,
        isAllowedVerifyAccount: true,
        isAllowedVerifySlip: true,
        configs: [
            { key: 'apiCustomerKey', label: 'Customer Key' },
            { key: 'bankId', label: 'Bank ID' },
            { key: 'merchantId', label: 'Merchant ID' },
            { key: 'secretKey', label: 'Secret Key' },
            DEPOSIT_DISPLAY_TYPE_CONFIG,
        ]
    },
    'cubix-pay': {
        name: 'CubixPay',
        isAllowedDeposit: true,
        isAllowedWithdraw: true,
        isAllowedVerifyAccount: false,
        isAllowedVerifySlip: false,
        configs: [
            { key: 'apiKey', label: 'API Key' },
            { key: 'apiSecret', label: 'API Secret' },
            DEPOSIT_DISPLAY_TYPE_CONFIG,
        ]
    },
    'p2cpay': {
        name: 'P2CPay',
        isAllowedDeposit: true,
        isAllowedWithdraw: true,
        isAllowedVerifyAccount: true,
        isAllowedVerifySlip: true,
        configs: [
            { key: 'apiKey', label: 'API Key' },
            { key: 'secretKey', label: 'Secret Key' },
            DEPOSIT_DISPLAY_TYPE_CONFIG,
        ]
    },
    'askpay': {
        name: 'AskPay',
        isAllowedDeposit: true,
        isAllowedWithdraw: true,
        isAllowedVerifyAccount: false,
        isAllowedVerifySlip: true,
        configs: [
            { key: 'publicKey', label: 'Public Key' },
            { key: 'secretKey', label: 'Secret Key' },
            { key: 'depositProviderCode', label: 'Deposit Provider Code', options: ASKPAY_PROVIDER_CODES },
            { key: 'withdrawProviderCode', label: 'Withdraw Provider Code', options: ASKPAY_PROVIDER_CODES },
            DEPOSIT_DISPLAY_TYPE_CONFIG,
        ]
    },
    'askpayy': {
        name: 'AskPayy',
        isAllowedDeposit: true,
        isAllowedWithdraw: false,
        isAllowedVerifyAccount: false,
        isAllowedVerifySlip: true,
        configs: [
            { key: 'publicKey', label: 'Public Key' },
            { key: 'secretKey', label: 'Secret Key' },
            DEPOSIT_DISPLAY_TYPE_CONFIG,
        ]
    }
}

// ประเภทรายการที่ทำให้ยอดคงเหลือของ payment gateway ขยับ (ตรงกับ enum ฝั่ง API)
export const PAYMENT_GATEWAY_BALANCE_LOG_TYPE = {
    deposit: { label: 'ฝากออโต้', variant: 'success' },
    withdraw: { label: 'ถอนออโต้', variant: 'danger' },
    manual_deposit: { label: 'ฝากมือ', variant: 'success' },
    manual_withdraw: { label: 'ถอนมือ', variant: 'danger' },
    pull_back: { label: 'ดึงรายการฝากคืน', variant: 'warning' },
    redo: { label: 'ทำรายการฝากที่ดึงคืนใหม่', variant: 'info' },
    increase: { label: 'แอดมินเพิ่มยอด', variant: 'success' },
    decrease: { label: 'แอดมินลดยอด', variant: 'danger' },
    set: { label: 'แอดมินตั้งยอด', variant: 'primary' },
}

export const PAYMENT_GATEWAY_BALANCE_LOG_TYPES = Object.keys(PAYMENT_GATEWAY_BALANCE_LOG_TYPE)

// ประวัติเก็บย้อนหลังแค่ 3 เดือน (cron ลบของเก่ากว่านั้นทุกวัน)
export const PAYMENT_GATEWAY_BALANCE_LOG_MAX_MONTHS = 3
